module.exports = __webpack_public_path__ + "img/arrow.cf2a4046.svg";